module.exports = __webpack_public_path__ + "media/customizations/lmdb/logo-72d7baae1d3aa6624daa6190c5189f1f.png";